import algoliasearch from 'algoliasearch'
import { invariant } from 'utils/invariant'
import algoliaAnalytics from 'search-insights'
import ms from 'ms'

export const env = (value: string | undefined, message: string): string => {
  invariant(value, message)
  return value
}

export const algoliaAppId = env(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID || process.env.VITE_ALGOLIA_APP_ID,
  'NEXT_PUBLIC_ALGOLIA_APP_ID or VITE_ALGOLIA_APP_ID is not set',
)
export const algoliaApiKey = env(
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY || process.env.VITE_ALGOLIA_API_KEY,
  'NEXT_PUBLIC_ALGOLIA_API_KEY or VITE_ALGOLIA_API_KEY is not set',
)

export const algoliaProductIndex = env(
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX || process.env.VITE_ALGOLIA_PRODUCT_INDEX,
  'NEXT_PUBLIC_ALGOLIA_INDEX or VITE_ALGOLIA_PRODUCT_INDEX is not set',
)

export const algoliaProductsIndexNewest = `${algoliaProductIndex}${
  algoliaProductIndex.includes('trending') ? '' : '_trending'
}_newest`
export const algoliaProductsIndexOldest = `${algoliaProductIndex}${
  algoliaProductIndex.includes('trending') ? '' : '_trending'
}_oldest`

export const defaultSearchClient = algoliasearch(algoliaAppId, algoliaApiKey, {
  headers:
    typeof window === 'undefined'
      ? {
          referer: 'https://www.creativefabrica.com',
        }
      : {},
})

export interface AlgoliaSearchedProductsLocalStorage {
  items: Record<string, Record<string, string>>
  expiresAt: Date
}

algoliaAnalytics('init', {
  appId: algoliaAppId,
  apiKey: algoliaApiKey,
  useCookie: true,
  cookieDuration: ms('90 days'),
})

// eslint-disable-next-line no-barrel-files/no-barrel-files
// oxlint-disable-next-line cf-web/no-barrel-file
export { algoliaAnalytics }

export enum AlgoliaEventName {
  PRODUCT_CLICKED = 'Product Clicked',
  PRODUCT_VIEWED = 'Product Viewed',
  PRODUCT_DOWNLOADED = 'Product Downloaded',
  PRODUCT_LIST_VIEWED = 'Product List Viewed',
  PRODUCTS_SEARCHED = 'Products Searched',
}
